const ValidationError = require('./errors/ValidationError');
const { banks, errors } = require('@transfeeradev/api-enums');
const Default = require('./Default');

module.exports = class C6Bank extends Default {
  constructor(data) {
    super('C6 Bank', data, banks.C6_BANK.code);
    this._data.agency = this._removeUnnecessaryLeadingZeros(this._data.agency, this._agencySchemaLength);
    this._data.account = this._removeUnnecessaryLeadingZeros(this._data.account, this._accountSchemaLength);
  }

  _validateAccount() {
    super._validateAccount();

    const accDigit = this.getAccountDigit().toString();

    if (accDigit.toLowerCase() !== this._data.account_digit.toString().toLowerCase()) {
      const error = errors.ptBr.dba.ACCOUNT_OR_ACCOUNT_DIGIT_INVALID;
      throw new ValidationError(
        error.message,
        error.field,
        {
          account_digit: accDigit
        },
        error.code
      );
    }
  }

  getAccountDigit() {
    const multipliers = [4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const accountNumber = this._fillZero(this._data.account, this._accountSchemaLength);

    const accountNumberSum = accountNumber
      .split('')
      .filter(digit => !isNaN(digit))
      .map((digit, index) => Number(digit) * multipliers[index])
      .reduce((sum, number) => sum + number, 0);

    const mod = (accountNumberSum * 10) % 11;
    if (mod >= 10) return 0;

    return mod;
  }

  validate() {
    const errors = [];

    try {
      this._validateBank();
    } catch (e) {
      errors.push(this._catchValidationErrors(e));
    }

    try {
      this._validateAgency();
    } catch (e) {
      errors.push(this._catchValidationErrors(e));
    }

    try {
      this._validateAccountType();
    } catch (e) {
      errors.push(this._catchValidationErrors(e));
    }

    try {
      this._validateAccount();
    } catch (e) {
      errors.push(this._catchValidationErrors(e));
    }

    return errors;
  }
};
